// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"95d706a0fa00b505a7db","3":"4339e1d763de14043440","4":"4a6c0686bb6911381923","5":"fb2a5c689aa390719bc5"}[chunkId] + "";
};